type LookupGeneration = {
  begin: () => number;
  cancel: () => void;
  isCurrent: (token: number) => boolean;
};

export const createLookupGeneration = (): LookupGeneration => {
  let current = 0;

  return {
    begin: () => {
      current += 1;
      return current;
    },
    cancel: () => {
      current += 1;
    },
    isCurrent: (token: number) => token === current,
  };
};

export const settleLookup = <T>(params: {
  generation: LookupGeneration;
  token: number;
  result: { ok: true; value: T } | { ok: false; error: unknown };
}): { apply: T | null; error: unknown | null } => {
  if (!params.generation.isCurrent(params.token)) {
    return { apply: null, error: null };
  }
  if (params.result.ok) {
    return { apply: params.result.value, error: null };
  }
  return { apply: null, error: params.result.error };
};
